import { render, staticRenderFns } from "./ManualOrderConfigurationFee.vue?vue&type=template&id=ff332f56&scoped=true"
import script from "./ManualOrderConfigurationFee.vue?vue&type=script&lang=js"
export * from "./ManualOrderConfigurationFee.vue?vue&type=script&lang=js"
import style0 from "./ManualOrderConfigurationFee.vue?vue&type=style&index=0&id=ff332f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff332f56",
  null
  
)

export default component.exports